import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { SampleDataStatusResponse } from "../contracts/SampleDataStatusResponse";
import { LoadSampleDataRequest } from "../contracts/LoadSampleDataRequest";

export const fetchSampleDataStatus = createAsyncThunk<
  SampleDataStatusResponse,
  void,
  { rejectValue: ApiErrorResponse }
>("sampleData/fetchStatus", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<SampleDataStatusResponse>("/sample-data");
    return response.data;
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to load the sample data status"));
  }
});

export const loadSampleData = createAsyncThunk<
  SampleDataStatusResponse,
  LoadSampleDataRequest,
  { rejectValue: ApiErrorResponse }
>("sampleData/load", async (request, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post<SampleDataStatusResponse>("/sample-data", request);
    return response.data;
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to load sample data"));
  }
});

export const removeSampleData = createAsyncThunk<
  void,
  void,
  { rejectValue: ApiErrorResponse }
>("sampleData/remove", async (_, { rejectWithValue }) => {
  try {
    await axiosInstance.delete("/sample-data");
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to remove the sample data"));
  }
});
